// extracted by mini-css-extract-plugin
export default {"component":"SmsBundle_component__f8XYD","flex":"SmsBundle_flex__m5pZg"};